import * as React from "react"
import { Box } from "@mui/material";
import {SelectSeeker} from "@ui-seeker/core";

import {GROUPED_BY} from "@constants"


export const OPTIONS = [
	{ label: 'Global Market', value: GROUPED_BY.COUNTRY },
	{ label: 'Retailer', value: GROUPED_BY.RETAILER }
]

export default function SkuDetailsProductPageKpisActions({ optionSelected, handleChangeOption }) {
	return <Box sx={{ display: 'flex', justifyContent: 'flex-end'}}>
        <SelectSeeker
            options={OPTIONS}
            label="Group By"
            sx={{ width: 150}}
            value={optionSelected}
            onChange={handleChangeOption}
	    />
    </Box>  
}